import { createSelector } from 'reselect'
import { RootState } from '../types'
import { LoadingStateEnum } from '../../types'

export const getCrmRulesList = (state: RootState): RootState['crmRules']['list'] => state.crmRules.list

export const getRiskScoreRulesLoadingState = createSelector(getCrmRulesList, (list): LoadingStateEnum => list.loading)

export const riskScoreRulesLoading = createSelector(
  getRiskScoreRulesLoadingState,
  (loading): boolean => loading === LoadingStateEnum.LOADING,
)

export const getCrmRuleDetails = (state: RootState): RootState['crmRules']['details'] => state.crmRules.details

export const getRiskScoreRuleDetailsLoadingState = createSelector(
  getCrmRuleDetails,
  (details): LoadingStateEnum => details.loading,
)

export const riskScoreRuleDetailsLoading = createSelector(
  getRiskScoreRuleDetailsLoadingState,
  (loading): boolean => loading === LoadingStateEnum.LOADING,
)
